import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Register from './screens/Register';
import AdminLogin from './screens/AdminLogin';
import Dashboard from './screens/Dashboard';
import Dealers from './screens/Dealers';
import Users from './screens/Users';
import Benchmarks from './screens/Benchmarks';
import HphBenchmarks from './screens/HphBenchmarks';
import BenchmarkMode from './screens/BenchmarkMode';
import SurveySetup from './screens/SurveySetup';
import Reports from './screens/Reports';
import Settings from './screens/Settings';
import Billing from './screens/Billing';
import License from './screens/License';
import { ONPREM } from './edition';
import Impersonate from './screens/Impersonate';
import Legal from './screens/Legal';
import { ForgotPassword, ResetPassword } from './screens/PasswordReset';
import DemoStart from './demo/DemoStart';

const API = process.env.REACT_APP_API_URL || 'https://web-production-87efe.up.railway.app';
export { API };

// The web demo build (REACT_APP_DEMO=1): a stand-in server inside the page, sample data,
// and only these pages (the rest send the visitor to the Dashboard)
export function isDemo() {
  return process.env.REACT_APP_DEMO === '1';
}
export const DEMO_PAGES = ['/dashboard', '/reports', '/dealers', '/benchmarks', '/hph-benchmarks', '/survey'];

function PrivateRoute({ children }) {
  const token = localStorage.getItem('admin_token');
  return token ? children : <Navigate to="/login" />;
}

function DemoOff() {
  return <Navigate to="/dashboard" replace />;
}

function AdminOnlyRoute({ children }) {
  const token = localStorage.getItem('admin_token');
  if (!token) return <Navigate to="/login" />;
  const role = localStorage.getItem('admin_role');
  if (role !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL || undefined}>
      <Routes>
        <Route path="/register" element={ONPREM ? <Navigate to="/login" replace /> : <Register />} />
        <Route path="/terms" element={<Legal />} />
        <Route path="/privacy" element={<Legal />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/login" element={isDemo() ? <DemoStart /> : <AdminLogin />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/dealers" element={<PrivateRoute><Dealers /></PrivateRoute>} />
        <Route path="/users" element={isDemo() ? <DemoOff /> : <AdminOnlyRoute><Users /></AdminOnlyRoute>} />
        <Route path="/benchmarks" element={<PrivateRoute><Benchmarks /></PrivateRoute>} />
        <Route path="/hph-benchmarks" element={<PrivateRoute><HphBenchmarks /></PrivateRoute>} />
        <Route path="/benchmark-mode" element={isDemo() ? <Navigate to="/benchmarks" replace /> : <PrivateRoute><BenchmarkMode /></PrivateRoute>} />
        <Route path="/survey" element={<PrivateRoute><SurveySetup /></PrivateRoute>} />
        <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
        <Route path="/batch-reports" element={<Navigate to="/reports" replace />} />
        <Route path="/settings" element={isDemo() ? <DemoOff /> : <AdminOnlyRoute><Settings /></AdminOnlyRoute>} />
        <Route path="/billing" element={isDemo() ? <DemoOff /> : <AdminOnlyRoute>{ONPREM ? <License /> : <Billing />}</AdminOnlyRoute>} />
        <Route path="/impersonate" element={<Impersonate />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;